import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

/** Space function extended with its allocation percentage */
export type SpaceFunctionWithPercent = ents.extra.space.Function & {
  percent: number
  tags: { text: string; style: ds.color.Legacy.PredefinedStyle }[]
}

/** Shared component displaying the list of functional usage functionalizations */
@ngCore.Component({
  imports: [ngCommon.PercentPipe, ds.chart.Component, ds.tag.Component],
  selector: 'atn-space-functional-usage-functionalizations',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.display.chart.Type} */
  public readonly ChartTypeEnum = ents.core.display.chart.Type

  /** Configuration options for the Donut chart */
  public readonly donutChartOptions: ents.core.display.chart.config.Of<ents.core.display.chart.Type.Donut> =
    {
      displayLegend: true,
    }

  /** List of functionalizations to display */
  public readonly allocationsSg = ngCore.input.required<
    SpaceFunctionWithPercent[]
  >({
    alias: 'allocations',
  })

  /** Chart data to display */
  public readonly chartDataSg = ngCore.input.required<
    ents.core.display.chart.data.Of<ents.core.display.chart.Type.Donut>
  >({
    alias: 'chartData',
  })

  /**
   * Formats the label for a given functionalization, including its categorization if available.
   */
  public readonly formatFunctionLabel = ({
    idcCategorization,
    name,
  }: SpaceFunctionWithPercent) =>
    idcCategorization?.subcategory
      ? `${name} - ${idcCategorization.category.code} (${idcCategorization.subcategory.code})`
      : `${name} - ${idcCategorization?.category.code ?? 'Uncategorized'}`
}
